<template>
  <el-form :model="workOrder" label-width="120px">
    <template v-if="tagOptions.length === 0">
      <div class="empty">无可选标签项</div>
    </template>
    <template v-else>
      <el-form-item
        v-for="item in tagOptions"
        :key="item.id"
        :label="`${item.labelGroupName}(${
          item.pattern === 'RADIO' ? '单选' : '多选'
        })`"
      >
        <el-button
          v-for="(tag, index) in item.labelName"
          :key="index"
          :type="showTag(item.id, tag)"
          @click="handleClick(item, tag)"
          round
          size="small"
          :disabled="loading"
        >
          {{ tag }}
        </el-button>
      </el-form-item>
    </template>
  </el-form>
</template>

<script>
import api from "plus/api";
import { groupBy, throttle } from "lodash";

export default {
  name: "workOrderTagInfo",
  props: {
    workOrder: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tagOptions: [],
      loading: false,
    };
  },
  computed: {
    tags() {
      return groupBy(this.workOrder.labelName, "labelGroupId");
    },
  },
  watch: {
    "workOrder.qaTypeId": {
      handler(val) {
        if (val) {
          this.getTags();
        }
      },
      deep: true,
    },
  },
  methods: {
    async getTags() {
      const response = await api.manage.getTagsByQaTypeId({
        qaTypeId: this.workOrder.qaTypeId,
      });
      this.tagOptions = response.data.data;
    },
    markTag(params) {
      return api.manage.markTag(params);
    },
    showTag(groupId, tag) {
      const isSelected =
        this.workOrder.labelName &&
        this.workOrder.labelName.some((item) => {
          return (
            item.labelGroupId.toString() === groupId.toString() &&
            item.labelName === tag
          );
        });
      if (isSelected) {
        return "success";
      }
    },
    handleClick: throttle(function (group, tag) {
      const params = {
        labelGroupId: group.id,
        labelName: tag,
        markingType: "MARKING",
        wkOrderId: this.workOrder.wkOrderId,
      };
      const hasTag =
        this.tags[group.id] &&
        this.tags[group.id].some((item) => item.labelName === tag);
      if (hasTag) {
        params.markingType = "CANCEL_MARKING";
      }
      this.loading = true;
      this.markTag(params)
        .then((res) => {
          this.loading = false;
          this.$emit("change");
        })
        .catch((e) => {
          this.loading = true;
        });
      // let list = []
      // if (group.pattern === 'RADIO') {
      //   list = this.tags[group.id] && this.tags[group.id].map(item => {
      //     return Object.assign({}, params, {labelName: item.labelName, markingType: "CANCEL_MARKING"})
      //   }) || []
      //   const hasTag = this.tags[group.id] && this.tags[group.id].some(item => item.labelName === tag)
      //   if (!hasTag) {
      //     list.push(params)
      //   }
      // } else {
      //   const hasTag = this.tags[group.id] && this.tags[group.id].some(item => item.labelName === tag)
      //   if (hasTag) {
      //     params.markingType = "CANCEL_MARKING"
      //   }
      //   list.push(params)
      // }
      // Promise.all(list.map(item => this.markTag(item))).then(res => {
      //   this.$emit("change")
      // }).catch((res) => {
      //   this.$emit("change")
      // })
    }, 1000),
  },
};
</script>

<style lang="less" scoped>
.el-tag {
  margin-right: 10px;
  margin-bottom: 10px;
}

.empty {
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
